import React, { FC, memo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { AppRoutes } from 'app/config/routerConfig/types';
import { useGetRentOptionsQuery } from 'entities/RentOption';
import { useSpecialPromotionModal } from 'features/SpecialPromotion';
import { Button } from 'shared/ui/Button';
import EasterBackground from 'shared/assets/images/EasterBackground.png';
import EasterBackgroundMobile from 'shared/assets/images/EasterBackgroundMobile.png';
import { ReactComponent as EasterIcon } from 'shared/assets/icons/EaterIcon.svg';
import { ReactComponent as EasterBoxIcon } from 'shared/assets/icons/EasterBoxIcon.svg';
import { ReactComponent as EasterCalendarIcon } from 'shared/assets/icons/EasterCalendarIcon.svg';
import { ReactComponent as EasterMarkIcon } from 'shared/assets/icons/EasterMarkIcon.svg';
import { useScreenBreakpoints } from 'shared/utils/hooks/useScreenBreakpoints';

export const EasterPromotionContent: FC = memo(() => {
  const { t } = useAppTranslation('common');

  const navigate = useNavigate();

  const { data } = useGetRentOptionsQuery({ isSpecialPromotion: true });
  const { closeModal } = useSpecialPromotionModal();

  const { isDesktop } = useScreenBreakpoints();

  const goToBooking = useCallback(() => {
    navigate(data?.length ? `${AppRoutes.BOOKING}?rentOptionId=${data[0].rentOptionId}` : AppRoutes.BOOKING);
    closeModal();
  }, [closeModal, data, navigate]);

  return (
    <div>
      <img className="w-full" src={isDesktop ? EasterBackground : EasterBackgroundMobile} alt="Easter" />
      <div className="flex flex-col items-center absolute top-[40%] desktop:top-[43%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-full p-10 desktop:p-24 text-center">
        <EasterIcon className="mb-2 w-[230px] desktop:my-8 desktop:w-[485px]" />

        <div className="text-[18px] desktop:text-[24px] font-bold text-[#E36E57] my-2 desktop:my-4">
          {t('Rabatte statt Schokolade – 25% in unserem Osterei!')}
        </div>
        <div className="text-sm desktop:text-[18px] text-[#44596B]">{t('Je größer Ihre Box, desto mehr profitieren Sie:')}</div>
        <div className="text-sm px-8 desktop:text-[18px] font-bold text-[#E3A014] text-center my-2 desktop:my-4">
          {t('Sie sparen 25 % auf Ihre Monatsmiete - so viele Monate,')}
          <br />
          {t('wie Ihre Lagerbox Quadratmeter hat!')}
        </div>
        <div className="text-sm desktop:text-[18px] text-[#44596B] flex gap-2 items-center">
          <EasterCalendarIcon className="w-[20px]" />
          {t('Nur vom 14. bis 22. April 2025')}
        </div>
        <div className="text-sm desktop:text-[18px] text-[#44596B] flex gap-2 items-center">
          <EasterMarkIcon className="w-[20px]" />
          {t('Nur für Neukunden')}
        </div>
        <div className="text-sm desktop:text-[18px] text-[#44596B] flex gap-2 items-center">
          <EasterBoxIcon className="w-[20px]" />
          {t('Mindestmietdauer: nur 1 Monat')}
        </div>
        <Button
          containerClassName="min-w-[280px] max-w-[351px] mt-3 desktop:mt-6"
          className="!bg-[#E36E57]"
          fontSize={isDesktop ? 'large' : 'medium'}
          onClick={goToBooking}
        >
          {t('Jetzt Oster-Rabatt sichern!')}
        </Button>
      </div>
    </div>
  );
});
